import {createRequest, makeRequest} from "../utils/apiUtil";

export function get() {
    return makeRequest(createRequest('contact-request'));
}